module.exports = __webpack_public_path__ + "img/dKkWrekj.50d359f2.svg";